import React, { useRef, useState } from 'react'
import Modal from '../../../../common/components/modal/Modal'
import { Text } from '../../../../common/components/text/Text'
import { Col, Form, Row, Button } from 'react-bootstrap'
import '../../../../common/components/button/Button.scss'
import '../../../../common/components/control/Control.scss'
// import { Input, Select, Textarea } from '../../../../common/components/control/Control'
// import { Button } from '../../../../common/components/button/Button'
import { Flex } from '../../../../common/components/flex/Flex'
import Icons from '../../../../common/components/icon/Icon'
import { Space } from '../../../../common/components/space/Space'
import { connect } from 'react-redux'
import classNames from 'classnames'
import { useForm } from 'react-hook-form'
import '../Company.scss'
import { useEffect } from 'react'
import swal from 'sweetalert'
import typeService from '../../../../services/typeService'
import Loader from 'react-loader-spinner';      

interface companyProps {
  id: string;
  name: string;
  description: string;
}

interface FormData {
  txt_cmpName: string;
  txt_cmpDescription: string;
}

const AddCompany = (props: any) => {
  const { register, handleSubmit, errors } = useForm<FormData>({
    mode: 'onSubmit',
    reValidateMode: 'onBlur',
  });
  const [cmpTypeaddflag, setcmpTypeAddFlag] = React.useState(false)
  const [isLoading, setLoading] = React.useState(false)
  const { cmpType } = props
  const { edit } = props
  const { view } = props
  const { id } = props
  //const { add } = props
  const { onClose } = props
  const [form, setForm] = useState<companyProps>({
    id: '',
    name: '',
    description: ''
  })
  const [editForm, setEditForm] = useState({
    id: '',
    name: '',
    description: ''
  })

  const [modalTitle, setModalTitle] = useState('')
  function usePrevious(value: any) {
    const ref = useRef();
    useEffect(() => {
      ref.current = value;
    });
    return ref.current;
  }

  const prevUser = usePrevious(cmpType);

  useEffect(() => {
    if (cmpType && prevUser !== cmpType) {
      _getSelectedcmpType()
    }

    if (edit) {
      setModalTitle('Edit Company Type Detail')
    }

    else {
      setModalTitle('Company Type Detail')
    }
  }, [cmpType])

  const _getSelectedcmpType = () => {
    const { cmpType } = props
    setEditForm({
      id: cmpType.id,
      name: cmpType.name,
      description: cmpType.description
    })
    // console.log(cmpType,'props user')
    // setForm({ 
    //   name: user.name,
    //   email: user.email,
    //   password: user.password,
    //   roles: [],
    //   role:user.roles.id,
    //   status: user.status
    //  })
    //  console.log(form,'userForm')
  }

  const _didCmpTypeAdd = () => {
    // e.preventDefault()
    const { onClose } = props

    const payload = {
      name: editForm.name,
      description: editForm.description,
    }
    if (cmpTypeaddflag === true) {
      if (edit) {
        _willUpdate()

      }
      else {
        setLoading(true)
        typeService.addCmpType(payload).subscribe({
          next: (r) => {
            setLoading(false)
            swal("Great", "New Company Type Added Successfully", "success")
            onClose()
          },
          error: err => {
            setLoading(false)
            console.error(err)
            swal("OOPS", String(err), "error")
          }
        })
      }
    }
    else {
      console.log(cmpTypeaddflag)
    }

  }
  const _willUpdate = () => {
    const { onClose } = props
    const { user_id } = props
    const updatepayload = {
      id: Number(editForm.id),
      name: editForm.name,
      description: editForm.description,
    }
    setLoading(true)
    return typeService.updateCmpType(updatepayload).subscribe({
      next: () => {
        setLoading(false)
        swal("Great", "Company Type Updated Successfully", "success")
        onClose()
      },
      error: err => {
        setLoading(false)
        swal("OOPS", String(err), "error")
        console.error(err)
      }
    })
  }

  onsubmit = (e: any) => {
    // e.preventDefault()
    console.log(Object.keys(errors).length, 'error length')
    if (Object.keys(errors).length === 0) {
      _didCmpTypeAdd()
      setcmpTypeAddFlag(true)
    }
    else {
      setcmpTypeAddFlag(false)
    }
  }

  if (isLoading) {
    return <Text center>
        <Loader
            type="Rings"
            color="#233269"
            height={100}
            width={100}
            timeout={30000}
        />
    </Text>
}
  return (
    <Modal
      onClose={() => onClose()}
      title={!cmpType ? 'Add New Company' : modalTitle}>
      <ModalBody>
        <Form onSubmit={handleSubmit(onsubmit)} autoComplete='off' name='cityAddForms'>
          <Attributes>
            {/* {view && (
              <div>
                <Text color='black' variant='subtitle'>ID</Text>
                <Text color='main' bold variant='subtitle'>{editForm.id}</Text>
              </div>
            )} */}
            <div>
              <Text color='black' variant='subtitle'>Company Type</Text>
              {view && (
                <Text color='main' bold variant='subtitle'>{editForm.name}</Text>
              )}
              {!view && (
                <Form.Control className='basecontrol custome-input'
                  name="txt_cmpName"
                  placeholder='Company Type'
                  value={editForm.name}
                  ref={register({ required: true, })}
                  onChange={(e) => setEditForm({ ...editForm, name: e.target.value })}
                  type="text"
                />
              )
              }
            </div>
            <Row className='m-0 p-0'>
              <Col xs='12' md='12' lg='3' xl='3' className='p-0 m-0 ml-3'>
              </Col>
              <Col xs='12' md='12' lg='12' xl='12' className='p-0 m-0'>
                <span className='err-msg text-capitalize'>{errors.txt_cmpName?.type === 'required' && 'Please enter Company Name'}
                </span>
              </Col>
            </Row>
            <div>
              <Text color='black' variant='subtitle'>Description</Text>
              {view && (
                <Text color='main' bold variant='subtitle'><p>{editForm.description}</p></Text>
              )}
              {!view && (
                <Form.Control as="textarea" className='basecontrol custome-textarea'
                  rows={3}
                  cols={50}
                  name="txt_cmpDescription"
                  placeholder='Description'
                  value={editForm.description}
                  onChange={(e) => setEditForm({ ...editForm, description: e.target.value })}
                // ref={register({ required: true,})}
                />
              )}
            </div>
            {/* <Row className='m-0 p-0'>
              <Col xs='12' md='12' lg='3' xl='3' className='p-0 m-0 ml-3'>
              </Col>
              <Col xs='12' md='12' lg='12' xl='12' className='p-0 m-0'>
              <span className='err-msg text-capitalize'>{errors.txt_cmpDescription?.type === 'required' && 'Please enter Description'}
                  </span>
              </Col>
            </Row> */}
          </Attributes>
          <Space divheight={20} />
          <Flex jc='jc-center'>
            <Button
              type="button"
              onClick={() => onClose()}
              className='bttn bttn-transparent'>
              <Flex>
                <Icons icon="arrow_back" />
                BACK
              </Flex>
            </Button>
            {!view && (
              <Button className='bttn bttn-transparent' type="submit">
                <Flex>
                  <Icons color="#ffffff" icon="check" />
                  SAVE DATA
                </Flex>
              </Button>
            )}
          </Flex>
        </Form>
      </ModalBody>
    </Modal>
  )
}

export interface ModalbodyProps {
  children?: React.ReactNode
}

export const ModalBody = ({ children, ...props }: ModalbodyProps) => {

  const modal = classNames('modalbody-container')

  return (
    <div className={modal}>
      {children}
    </div>
  )

}
export interface AttributeProps {
  children?: React.ReactNode
}
export const Attributes = ({ children, ...props }: AttributeProps) => {
  const attribute = classNames('attribute-container');

  return (
    <div {...props} className={attribute} >
      {children}
    </div>
  )
}

const mapStateToProps = (state: any) => ({
  cmpType: state.cmpTypes.selectedCmpTypes
})
export default connect(
  mapStateToProps)(AddCompany)
